export const estoqueDisponiveis = [
  "AVUL"
]

export const depositoEspeciais = [
  "INTE", "BMAN", "BSEL"
]
